import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import EnvCropsProductsContext from './EnvCropsProductsContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const EnvCropsProductsProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <EnvCropsProductsContext.Provider value={{ actions, selectors, state }}>
      {children}
    </EnvCropsProductsContext.Provider>
  );
};

export default EnvCropsProductsProvider;
